import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const CardNumberInput = ({
  value,
  onChange,
  placeholder = '**** **** **** ****',
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  const formatCardNumber = (input) => {
    // Remove tudo que não é dígito
    const cleaned = input.replace(/\D/g, '');
    
    // Limita a 16 dígitos
    const limited = cleaned.slice(0, 16);
    
    // Adiciona espaços a cada 4 dígitos
    const formatted = limited.replace(/(\d{4})(?=\d)/g, '$1 ');
    
    return formatted;
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatCardNumber(inputValue);
    
    // Chama onChange com o valor limpo (apenas números)
    const rawValue = formattedValue.replace(/\D/g, '');
    onChange && onChange(rawValue);
  };

  const displayValue = value ? formatCardNumber(value) : '';

  return (
    <Input
      value={displayValue}
      onChange={handleChange}
      placeholder={placeholder}
      maxLength={19} // 16 dígitos + 3 espaços
      style={{
        backgroundColor: theme.background,
        color: theme.textSecondary,
        borderColor: theme.border,
        ...style
      }}
      className={className}
      {...props}
    />
  );
};

CardNumberInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default CardNumberInput; 